<script setup>
/**
 * @fileoverview TabsList component
 * @description Container for tab triggers
 */
import { TabsList as TabsListPrimitive } from 'radix-vue'
import { cn } from '@/lib/utils'

const props = defineProps({
  class: {
    type: String,
    default: ''
  }
})
</script>

<template>
  <TabsListPrimitive
    :class="
      cn(
        'inline-flex h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground',
        props.class
      )
    "
  >
    <slot />
  </TabsListPrimitive>
</template>
